export enum PaymentSystems {
  JCC = 'JCC',
  PBT = 'PBT',
  Six = 'SIX',
  Viva = 'VIVA',
}
